import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PropertiesSettings } from '../../../core/configuration/properties-settings';
import { ModalNotifyService } from '../../../core/services/modal-notify.service';
import { OperationsService } from '../../../core/services/operations.service';
import { RoutingConfigurationUtilService } from '../../../core/services/routing-configuration-util.service';
import { ViewManagerService } from '../../../core/services/view-manager-service';
import { ProfiloUtente } from '../../models/profilo-utente';

@Component({
  selector: '[footer-fascicolo-wizard]',
  templateUrl: 'footer-fascicolo-wizard.component.html',
  host: { '[class.standardpanel]': '\'true\'' }
})

export class FooterFascicoloWizardComponent implements OnInit {

  private userProfile: ProfiloUtente;
  private waitProcess: boolean = false;

  @Input()
  nextStep: string;

  @Input()
  mnc: number;

  @Input()
  fascicoloId: string;

  @Input()
  fascicolo;

  @Input()
  routingSmistamento: string;

  @Input()
  urlConcludiInserimento: string;

  @Input()
  urlConcludiAssegnazione: string;

  @Input()
  isDatiEconomici: boolean;

  @Input()
  isDatiGenerali: boolean;

  @Input()
  disabled: boolean;

  @Output()
  onSubmitDatiEconomiciForm= new EventEmitter();


  constructor(private operationService: OperationsService, private modalNotifyService: ModalNotifyService, private routingService: RoutingConfigurationUtilService, private viewManager: ViewManagerService) {
  }

  ngOnInit() {
    this.routingSmistamento = this.routingSmistamento + '/' + this.fascicolo.id;
    this.operationService.getUserProfile().subscribe(response => this.userProfile = response.profilo);
  }

  onCompleteCallback() {
    this.mnc = 0;
  }

  completaInserimentoFascicolo() {
    this.waitProcess = true;
    this.urlConcludiInserimento = this.urlConcludiInserimento;
    this.operationService.concludiFaseInserimento(this.fascicolo.id, this.urlConcludiInserimento).subscribe(response => this.notifyCompletedCallback(response));
  }

  notifyCompletedCallback(response) {
    this.waitProcess = false;
    this.viewManager._refreshAttivitaCompletare.next({param: response, timeOut: false});
    let msg = PropertiesSettings.MSG_GENERIC_SUCCESS;
    if (this.fascicolo && this.fascicolo.praticaBase) {
      msg = PropertiesSettings.MSG_SUCCESS_COMPLETA_FASCICOLO;
      msg = msg.replace('{posizionePratica}', this.fascicolo.praticaBase.posizione);
      msg = msg.replace('{posizioneFascicolo}', this.fascicolo.posizione);
    }
    if (this.userProfile.smistatore) {
      this.modalNotifyService.notifySuccessCompleteFascicolo(response, this.routingSmistamento, this.fascicoloId, msg);
    } else {
      if (!this.userProfile.smistatore) {
        this.notifyAndbackHome(response, msg);
      }
    }
  }

  notifyAndbackHome(response, msg) {
    //this.viewManager._refreshAttivitaCompletare.next();
    this.modalNotifyService.notifySuccessCompleteFascicolo(response, '', null, msg);
  }

  exitCallback() {
    this.modalNotifyService.notifyAndExitCallback();
  }

  isLastStepWizard(): boolean {
    return this.nextStep.indexOf(PropertiesSettings.LAST_STEP_WIZARD) >= 0;
  }

  concludiAssegnazioneLegale() {
     if (this.userProfile && this.userProfile.assegnatario) {
      this.waitProcess = true;
      this.operationService.concludiFaseAssegnazioneLegale(this.urlConcludiAssegnazione, this.fascicolo.id).subscribe(response => this.notifyAndbackHomeAfterConcludi(response));
    }
  }

  notifyAndbackHomeAfterConcludi(response) {
    this.waitProcess = false;
    //this.viewManager._refreshAttivitaCompletare.next();
    this.modalNotifyService.notifySuccessCallback(response, '', null);
  }

  isToComplete(fascicolo): boolean {
    let toComplete: boolean;
    toComplete = this.routingService.isFascicoloToComplete(fascicolo);
    return toComplete;
  }
}
